import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const StatementDeliveryPreferencesLookupState = (state: RootState) => state.lookups.statementDeliveryPreferences;

export const selectStatementDeliveryPreferences = (state: RootState) =>
  StatementDeliveryPreferencesLookupState(state).rows;
export const selectStatementDeliveryPreferencesLoading = (state: RootState) =>
  StatementDeliveryPreferencesLookupState(state).loading;

export const selectStatementDeliveryPreferenceById = createSelector(
  [selectStatementDeliveryPreferences, (_: RootState, id?: number) => id],
  (rows, id) => rows.find(({ id: rowId }) => String(id) === String(rowId)),
);

export const selectLookupStatementDeliveryPreferences = createSelector(selectStatementDeliveryPreferences, (rows) =>
  rows.map(({ id, name }) => ({ id, name })),
);
